import React, { useEffect, useState } from 'react';
import { Breadcrumb, Button, Dropdown, Spinner } from 'react-bootstrap';
import { connect } from 'react-redux';
import { downloadFile } from '../../../helpers/apiHandler';
import config from '../../../config/Constant';
import CustomAlert from '../../../components/CustomAlert';
import plusIcon from '../../../assets/SidebarIcons/icon-plus.svg';
import iconDownload from '../../../assets/SidebarIcons/icon-download.svg';

const PageHeading = ({ setDate, access_token, data }) => {
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [selectedRange, setSelectedRange] = useState('1 Day');
  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  const handleDownload = () => {
    setLoadingDownload(true);
    downloadFile(
      {
        url: '/v2/campaign-export',
        data: {
          data: data,
        },
        access_token: access_token,
        fileName: 'campaign-export.csv',
      },
      (res) => {
        if (!res.error) {
          setAlertState({
            message: 'Your campaign(s) have been successfully exported to excel.',
            show: true,
            variant: 'success',
          });
        } else {
          setAlertState({
            message: 'We apologize, but it seems there was an issue exporting your campaign(s) to Excel.',
            show: true,
            variant: 'danger',
          });
        }
        setLoadingDownload(false);
      }
    );
  };

  const handleRangeChange = range => {
    let selectedText;
    switch (range) {
      case '1_day':
        selectedText = '1 Day';
        break;
      case '7_day':
        selectedText = '7 Days';
        break;
      case '1_month':
        selectedText = '1 Month';
        break;
      case '3_month':
        selectedText = '3 Months';
        break;
      case '6_month':
        selectedText = '6 Months';
        break;
      case '12_month':
        selectedText = '12 Months';
        break;
      default:
        selectedText = '7 Days';
    }
    setSelectedRange(selectedText);
    setDate(range);
  };

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({
          message: '',
          show: false,
          variant: '',
        });
      }, config.notify_time);
    }
  }, [alertState]);

  return (
    <>
      <CustomAlert
        message={alertState.message}
        show={alertState.show}
        variant={alertState.variant}
        closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
      />
      <div className="page-heading campaign-overview-header" style={{ padding: "24px" }}>
        <div className="container-left" style={{ marginBottom: "16px"}}>
          <div className="page-title">SMS Campaign Overview</div>
        </div>
        <div className="container-right">
          <Button
            variant="primary"
            href="/dashboard/campaign/campaign-create/"
            style={{ minWidth: 160 }}
          >
            <img alt="..." src={plusIcon} />
            Create Campaign
          </Button>
          <Button
            variant="primary"
            disabled={loadingDownload}
            style={{ minWidth: 160 }}
            onClick={handleDownload}
          >
            {loadingDownload ? (
              <Spinner animation="border" size="sm" className="mr-2" />
            ) : (
              <img src={iconDownload} alt="..." style={{ marginRight: 8 }} />
            )}
            Export to Excel
          </Button>
          <Dropdown>
            <Dropdown.Toggle variant="ghost" style={{ minWidth: 160 }}>
              {selectedRange}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => handleRangeChange('1_day')}>1 Day</Dropdown.Item>
              <Dropdown.Item onClick={() => handleRangeChange('7_day')}>7 Days</Dropdown.Item>
              <Dropdown.Item onClick={() => handleRangeChange('1_month')}>1 Month</Dropdown.Item>
              <Dropdown.Item onClick={() => handleRangeChange('3_month')}>3 Months</Dropdown.Item>
              <Dropdown.Item onClick={() => handleRangeChange('6_month')}>6 Months</Dropdown.Item>
              <Dropdown.Item onClick={() => handleRangeChange('12_month')}>12 Months</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = state => {
  const { access_token, user } = state.auth;

  return {
    access_token,
    user,
  };
};

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PageHeading);
